
import { Component, Watch } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import UserMixin from '@/_mixins/user'

import { getCurrentUser, patchUser } from '@/utils/user'

import LanguageModel from '@/views/Language/models/language'
import { openDialog } from '@/_components/dialog/dialog'

import SelectLanguage from '@/components/Select/language.vue'
import CompanyAutocomplete from '@/components/Autocomplete/company.vue'
import Dialog from '@/components/Dialog/Dialog.vue'
import LeaveDialog from '@/components/leaveDialog.vue'

@Component({
    components: { SelectLanguage, CompanyAutocomplete, Dialog },
    mixins: [UserMixin],
})
export default class GeneralSettings extends Mixins<MixinInterface>(UserMixin) {
    loading = true
    loadingUpdate = false

    userBase: any = null
    user: any = {
        firstName: '',
        middleName: null,
        lastName: '',
        cardId: null,
        language: 'eng',
        timeZone: null,
        jobTitle: null,
        avatarFileId: null,
        employer: {
            data: null,
        },
    }

    valid = false
    error = false
    cardExistsOnOtherUser = false

    initializeUser(data: any) {
        this.userBase = JSON.parse(JSON.stringify(data))
        this.file = null
        Object.keys(this.user).map((key) => {
            this.user[key] = data[key]
        })
    }

    async getUserData() {
        try {
            this.loading = true
            const data = await getCurrentUser()
            if (data) {
                this.initializeUser(data)
            } else {
                this.error = true
            }
        } catch (error) {
            this.error = true
        } finally {
            this.loading = false
        }
    }

    async updateUser() {
        if (!this.userBase || !this.valid) return
        try {
            this.loadingUpdate = true
            let payload = {
                type: 'user',
                id: this.userBase.id,
                ...this.stagedChanges,
            }

            const data = await patchUser(this.userBase.id, payload)
            if (data) {
                this.initializeUser(data)
            }
        } catch (error) {
            if (error.data.response.data.errors[0].code) {
                this.cardExistsOnOtherUser = true
            }
        } finally {
            this.loadingUpdate = false
        }
    }

    cancle() {
        this.initializeUser(this.userBase)
    }

    get stagedChanges() {
        const result = {}
        if (!this.userBase) return result

        Object.keys(this.user).map((key) => {
            if (this.user[key] == '') this.user[key] = null

            if (key == 'employer') {
                if (this.user[key].data?.id != this.userBase[key].data?.id) {
                    result[key] = this.user[key]
                }
            } else {
                if (this.user[key] != this.userBase[key]) {
                    result[key] = this.user[key]
                }
            }
        })

        return result
    }

    get hasStagedChanges() {
        return !this.isObjectEmpty(this.stagedChanges)
    }

    // AVATAR
    file: any = null

    get maxBytes() {
        return this.userBase.constraints.avatarFileId.maxBytes
            ? this.userBase.constraints.avatarFileId.maxBytes
            : ''
    }

    get allowedExtensions() {
        return this.userBase.constraints.avatarFileId.allowedExtensions
            ? '.' + this.userBase.constraints.avatarFileId.allowedExtensions.join(',.')
            : ''
    }

    // Upload file
    loadingFile = false
    async uploadFile(fileObject: any) {
        this.loadingFile = true
        this.file = {
            links: {
                download: URL.createObjectURL(fileObject),
            },
            attributes: {
                fileId: null,
            },
        }

        let res = await this.postFile(fileObject).catch((error) => {
            this.$store.dispatch('errorSnackbar', 'Problems with uploading the file')
        })

        if (res) {
            this.user.avatarFileId = res
            this.file.fileId = res
        }
        this.loadingFile = false
    }

    @Watch('user.language', { deep: true })
    async getTranslations() {
        let userLangs = [this.user.language]
        if (process.env.NODE_ENV === 'production' && this.user.language !== 'eng') {
            userLangs.push('eng')
        }
        await LanguageModel.getFinalStrings(userLangs, ['front-end']).catch((error) => {
            console.log('getFinalStrings error', error)
        })
        this.$i18n.locale = this.user.language
        this.$i18n.setLocaleMessage(this.user.language, this.$store.getters.effectiveTexts)
    }

    // STATES
    async created() {
        await this.getUserData()
    }

    // LEAVING GUARD
    async beforeRouteLeave(to: any, from: any, next: any) {
        if (this.hasStagedChanges) {
            const navigateAway = await openDialog(LeaveDialog, {
                update: this.updateUser,
            })

            if (navigateAway) next()
        } else {
            next()
        }
    }
}
